import React from "react";
import ReactDOM from "react-dom";
import ClientDocumentSubscriptions from "../../components/ClientDocumentSubscriptions/ClientDocumentSubscriptions";

// Pharos Maintenance/OrganisationManagement.aspx, Client > Report Subscriptions tab (#3814).
const addClientDocumentSubscriptions = (api) => {
    const clientID = document.getElementById("ClientIDHiddenField")?.value;
    const container = document.getElementById("clientDocumentSubscriptions");

    if (clientID && container) {
        try {
            ReactDOM.render(
                <React.StrictMode>
                    <ClientDocumentSubscriptions api={api} clientID={clientID} />
                </React.StrictMode>,
                container
            );
        } catch (e) {
            console.error("Failed to render ClientDocumentSubscriptions:", e);
        }
    }
};

export default addClientDocumentSubscriptions;
